// Spawn odds (IMPLEMENTATION §0.2 R1, deposits.json oddsByLevel → compiled permille tables).
import { randBelow } from '../core/rng.ts';
import type { Int } from '../core/types.ts';
import type { OddsDef, SimDefs } from '../defs.ts';

/** Tier for one uint32 draw: [0,1000) by multiply-shift, then the cumulative permille table. */
export function rollTier(u32: Int, odds: readonly OddsDef[]): Int {
  const r = randBelow(u32, 1000);
  let acc = 0;
  for (const o of odds) {
    acc += o.permille;
    if (r < acc) return o.tier;
  }
  // The compiler guarantees each level sums to 1000; fall back to the last row defensively.
  const last = odds[odds.length - 1];
  if (!last) throw new RangeError('empty odds table');
  return last.tier;
}

export function oddsForLevel(d: SimDefs, level: Int): readonly OddsDef[] {
  const t = d.depositRules.oddsByLevel[level - 1];
  if (!t) throw new RangeError(`no deposit odds for level ${level}`);
  return t;
}
